
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetokolhapurcab() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Cab',
        heading: 'Meghana Cab : Pune to Kolhapur Cab',
        headingDescription: 'Meghana Cab offers Pune to Kolhapur Cab services, ensuring a comfortable and stress-free journey between these two historic cities. Whether you are traveling for business, pilgrimage, or a family visit, our clean and well-maintained cabs with experienced drivers provide a smooth and safe ride. Choose from a variety of vehicles suited to your needs and enjoy competitive pricing, on-time pickups, and 24/7 service. Book your Pune to Kolhapur Cab with Meghana Cab for a reliable and relaxing travel experience every time.',


        top: 'Top Places to Visit in Kolhapur with Meghana Cab',

      "topPlaces": [
  {
    "title": "Rankala Lake",
    "description": "A historic freshwater lake in the heart of Kolhapur, originally formed from a submerged quarry. Enjoy boating, strolls along the promenade, and views of the elegant Shalini Palace and surrounding gardens." 
  },
  {
    "title": "Panhala Fort",
    "description": "An imposing hill‑fort located about 20 km from the city⁠—built during the 12th century. Known as the ‘Fort of Snakes’, it offers panoramic views, historic gateways like Teen Darwaja, and intricate passages steeped in Maratha and Mughal history." 
  },
  {
    "title": "Mahalakshmi Temple",
    "description": "An important 7th‑century Shakti Peetha dedicated to Goddess Mahalakshmi. Famous for its Hemadpanthi architecture and black stone idol, it draws pilgrims and historians alike." 
  },
  {
    "title": "New Palace (Shri Chatrapati Shahu Museum)",
    "description": "A grand Indo‑Saracenic palace built between 1877–84. Today it houses a museum showcasing royal artifacts, a Darbar Hall, and artifacts ranging from weapons to royal costumes." 
  },
  {
    "title": "Jyotiba Temple",
    "description": "Situated about 18 km from Kolhapur, this hilltop shrine dedicated to Lord Jyotiba is known for its religious fairs and commanding views, especially spectacular during festivals." 
  },
  {
    "title": "Radhanagari Wildlife Sanctuary",
    "description": "Formerly known as Dajipur Bison Sanctuary, it's Maharashtra’s first wildlife reserve. Home to gaur (Indian bison), tigers, birds endemic to the Western Ghats, and lush forest trails." 
  },
  {
    "title": "Pohale Caves",
    "description": "A group of Buddhist rock‑cut caves dating back centuries, featuring viharas, a chaitya, and stone cells, located about 15 km northeast of the city." 
  },
  {
    "title": "Kaneri Math & Siddhagiri Gramjivan Museum",
    "description": "Located near Kolhapur, this complex includes Kaneri Math and a unique wax‑figure museum depicting traditional Maharashtrian village life as envisioned by Gandhi." 
  },
  {
    "title": "Gaganbawada (Morjai, Kode Lake region)",
    "description": "A scenic hill‑town around 45 km away, offering bike‑rides, trekking spots like Morjai Pathar, and tranquil lakes such as Kode Dam in lush Sahyadri landscapes." 
  },
  {
    "title": "Khasbag Maidan & Bhavani Mandap",
    "description": "A historic ground near Mahalakshmi Temple famous for wrestling matches (Kusti) and the adjacent Bhavani Mandap—an iconic heritage-style public building now functioning as a monument." 
  }
],

    "services": [
    {
        "name": "Pune to Kolhapur One Way Taxi",
        "description": "Book a one-way taxi from Pune to Kolhapur with Meghana Cab for a comfortable and affordable journey. Enjoy smooth travel with experienced drivers and clean, well-maintained vehicles."
    },
    {
        "name": "Cab Booking Pune to Kolhapur",
        "description": "Looking for a cab from Pune to Kolhapur? Meghana Cab offers quick and reliable cab booking services with instant confirmation and professional drivers for a hassle-free ride."
    },
    {
        "name": "Round Trip Cab Pune to Kolhapur",
        "description": "Plan a round trip from Pune to Kolhapur with Meghana Cab. Enjoy flexible travel schedules, clean vehicles, and courteous chauffeurs for a smooth and enjoyable round-trip experience."
    },
    {
        "name": "AC Cab from Pune to Kolhapur",
        "description": "Travel in comfort with Meghana Cab’s air-conditioned cabs from Pune to Kolhapur. Our AC vehicles ensure a relaxed and refreshing journey regardless of the weather."
    },
    {
        "name": "Pune to Kolhapur Sedan Taxi",
        "description": "Book a sedan taxi from Pune to Kolhapur for a comfortable and stylish travel experience. Perfect for small groups or business travelers seeking a smooth ride."
    },
    {
        "name": "SUV Rental Pune to Kolhapur",
        "description": "Need more space and comfort? Rent an SUV from Pune to Kolhapur with Meghana Cab. Ideal for families or groups with luggage, our SUVs offer both power and comfort."
    },
    {
        "name": "Pune to Kolhapur Travel by Car",
        "description": "Experience convenient car travel from Pune to Kolhapur with Meghana Cab. Enjoy scenic routes and a relaxing journey with our professional drivers and quality vehicles."
    },
    {
        "name": "Outstation Cab Pune to Kolhapur",
        "description": "Meghana Cab offers outstation cab services from Pune to Kolhapur. Choose from a range of vehicles and travel worry-free with our experienced drivers and prompt service."
    },
    {
        "name": "Pune to Kolhapur Highway Taxi",
        "description": "Book a highway taxi from Pune to Kolhapur for a quick and comfortable ride. Meghana Cab ensures a safe and efficient journey via the expressway with skilled chauffeurs."
    },
    {
        "name": "Budget Cab Pune to Kolhapur",
        "description": "Travel affordably from Pune to Kolhapur with Meghana Cab’s budget-friendly taxi services. Get great value without compromising on safety, cleanliness, or comfort."
    },
    {
        "name": "Driver-Included Cabs Pune to Kolhapur",
        "description": "Book a cab with an experienced driver from Pune to Kolhapur with Meghana Cab. Focus on your journey while we take care of the driving, ensuring safety and convenience."
    },
    {
        "name": "Online Taxi Booking for Kolhapur",
        "description": "Book your taxi to Kolhapur online with Meghana Cab. Our easy-to-use platform makes scheduling a ride simple and quick, with instant confirmation and support."
    },
    {
        "name": "Pune to Kolhapur Intercity Cab",
        "description": "Meghana Cab offers reliable intercity cab services from Pune to Kolhapur. Ideal for business trips, family travel, or weekend getaways, our service ensures a smooth ride."
    },
    {
        "name": "Book Hatchback Pune to Kolhapur",
        "description": "Looking for a compact ride? Book a hatchback from Pune to Kolhapur with Meghana Cab. An economical choice for solo travelers or couples, offering comfort at a great price."
    },
    {
        "name": "Pune to Kolhapur Car Hire Service",
        "description": "Hire a car from Pune to Kolhapur with Meghana Cab for a personalized travel experience. Choose from multiple vehicle options and enjoy a relaxed, private journey."
    }
],

"tableData": [
    ["Pune to Kolhapur One Way Taxi", "Cab Booking Pune to Kolhapur"],
    ["Round Trip Cab Pune to Kolhapur", "AC Cab from Pune to Kolhapur"],
    ["Pune to Kolhapur Sedan Taxi", "SUV Rental Pune to Kolhapur"],
    ["Pune to Kolhapur Travel by Car", "Outstation Cab Pune to Kolhapur"],
    ["Pune to Kolhapur Highway Taxi", "Budget Cab Pune to Kolhapur"],
    ["Driver-Included Cabs Pune to Kolhapur", "Online Taxi Booking for Kolhapur"],
    ["Pune to Kolhapur Intercity Cab", "Book Hatchback Pune to Kolhapur"],
    ["Pune to Kolhapur Car Hire Service", ""],
    ["", ""]
],





   "whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Kolhapur Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a comfortable and convenient cab service from Pune to Kolhapur. Whether it's a business trip, family visit, or leisure travel, we ensure a smooth and enjoyable ride across the distance."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop-Off",
        "WhyChoosedescription": "We understand the importance of punctuality for long-distance travel. Our Pune to Kolhapur cab service guarantees on-time pick-up and drop-off, helping you stay on schedule for meetings, events, or travel plans."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are skilled, courteous, and experienced in long-distance travel. They are well-acquainted with the Pune to Kolhapur route, ensuring a safe, efficient, and stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable Pune to Kolhapur Cab Fares",
        "WhyChoosedescription": "Meghana Cab offers competitive and transparent pricing for the Pune to Kolhapur route. Get affordable rates with no hidden charges, making your intercity travel budget-friendly and predictable."
    },
    {
        "WhyChooseheading": "Safe and Well-Maintained Vehicles",
        "WhyChoosedescription": "Safety is our top priority. Our cabs are well-maintained, sanitized, and equipped with modern safety features like seat belts and GPS tracking, ensuring a secure ride for all passengers."
    },
    {
        "WhyChooseheading": "24/7 Cab Service from Pune to Kolhapur",
        "WhyChoosedescription": "No matter what time you want to travel, Meghana Cab is available 24/7 to serve you. Book a Pune to Kolhapur cab at your convenience, be it early morning or late night."
    },
    {
        "WhyChooseheading": "Custom Travel Plans for Your Trip",
        "WhyChoosedescription": "Want to make stops along the way or plan a return journey? Meghana Cab offers customizable Pune to Kolhapur cab packages to fit your travel itinerary and personal preferences."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Support",
        "WhyChoosedescription": "Booking a cab from Pune to Kolhapur is easy with Meghana Cab. Use our website or mobile app to book in minutes, or reach out to our customer support team for assistance and quick confirmations."
    }
]














    }

 const faqData = [
    {
        question: "How can I book a Pune to Kolhapur cab with Meghana Cab?",
        answer: "You can book a Pune to Kolhapur cab easily through the Meghana Cab website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Kolhapur route?",
        answer: "Meghana Cab offers a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers based on your group size and comfort preference."
    },
    {
        question: "Is it a one-way or round-trip service from Pune to Kolhapur?",
        answer: "We provide both one-way and round-trip cab services from Pune to Kolhapur to suit your travel needs."
    },
    {
        question: "Are tolls and taxes included in the cab fare from Pune to Kolhapur?",
        answer: "Toll charges, state taxes, and parking fees are usually additional and are communicated clearly during the booking process."
    },
    {
        question: "How long does it take to travel from Pune to Kolhapur by cab?",
        answer: "The journey from Pune to Kolhapur typically takes around 4 to 5 hours depending on traffic and road conditions."
    },
    {
        question: "Is the Pune to Kolhapur cab service available at night?",
        answer: "Yes, Meghana Cab offers 24/7 cab services. You can schedule your trip anytime, including late-night or early-morning departures."
    },
    {
        question: "Can I make stops along the way from Pune to Kolhapur?",
        answer: "Yes, you can request halts during your trip. Kindly inform us in advance for a customized itinerary and accurate fare estimate."
    },
    {
        question: "Do your Pune to Kolhapur cabs come with experienced drivers?",
        answer: "Absolutely. All our cabs are driven by professional and experienced drivers familiar with the Pune to Kolhapur route."
    },
    {
        question: "What payment options are available for Pune to Kolhapur cab booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments to make your experience hassle-free."
    },
    {
        question: "How do I contact Meghana Cab for Pune to Kolhapur bookings?",
        answer: "For bookings and queries, feel free to call Meghana Cab at: +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sanjay Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked a cab from Pune to Kolhapur with Meghana Cab and the experience was excellent. The driver was courteous, the car was in great condition, and we had a smooth ride throughout.”',
    },
    {
        name: 'Mrs. Nisha Bhosale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our family trip from Pune to Kolhapur with Meghana Cab was extremely comfortable. The booking process was easy, and the service was reliable and punctual. Highly recommended!”',
    },
];










































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune to Kolhapur Cab",
//   "image": "https://www.meghanacabs.com/assets/images/pune-to-kolhapur-cab.jpg",
//   "description": "Book a reliable cab from Pune to Kolhapur with Meghana Cabs. Choose from Sedan, SUV, or AC cars for one-way or round trip travel. Affordable, on-time service with professional drivers.",
//   "brand": {
//     "@type": "Brand",
//     "name": "Meghana Cabs"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "5379"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2399",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.meghanacabs.com/pune-to-kolhapur-cab"
//   }
// };


// ✅ JSON-LD (put above your Helmet)
const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-to-kolhapur-cab#service",
  "serviceType": "Pune to Kolhapur Cab",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Kolhapur","Satara","Karad","Maharashtra"],
  "description": "Book reliable Pune to Kolhapur cabs with Meghana Cabs. Choose from Sedan, SUV, and AC cabs for one-way or round-trip travel. Safe, affordable, and 24x7 service.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "2499",
    "highPrice": "5999",
    "offerCount": "8",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-kolhapur-cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": 5741
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-kolhapur-cab.jpg",
  "priceRange": "₹₹",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Pune",
    "addressRegion": "MH",
    "addressCountry": "IN"
  },
  "areaServed": ["Pune","Kolhapur","Satara","Karad","Maharashtra"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [ "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday" ],
    "opens": "00:00",
    "closes": "23:59"
  }],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": 6217
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.meghanacabs.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Pune to Kolhapur Cab",
      "item": "https://www.meghanacabs.com/pune-to-kolhapur-cab"
    }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the starting fare for Pune to Kolhapur cab?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Fares start at ₹2499 for Sedan and vary by cab type and trip (one-way or round-trip). All charges are upfront and transparent."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to reach Kolhapur from Pune?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The journey usually takes 4.5 to 5.5 hours via NH48, depending on traffic and stopovers."
      }
    },
    {
      "@type": "Question",
      "name": "Which cab types are available for Pune to Kolhapur?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book Sedan, SUV, and premium AC cabs with Meghana Cabs. All vehicles are clean and well-maintained."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer one-way and round-trip options?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Meghana Cabs provides flexible one-way drop or full round-trip booking as per your requirement."
      }
    }
  ]
};





    return (
        <div>
<Helmet>
  <title>Pune to Kolhapur Cab | One Way & Round Trip Taxi Booking | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Kolhapur cab with Meghana Cabs. Affordable one-way & round-trip taxi service with Sedan, SUV, and AC cabs. Safe rides, 24x7 support, and professional drivers."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-to-kolhapur-cab" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  <meta
    name="keywords"
    content="Pune to Kolhapur Cab, Pune to Kolhapur Taxi, Pune to Kolhapur One Way Cab, Round Trip Cab Pune to Kolhapur, Sedan Cab Pune Kolhapur, SUV Cab Pune to Kolhapur, Pune to Kolhapur AC Taxi, Outstation Cab Pune to Kolhapur"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Kolhapur Cab | Meghana Cabs" />
  <meta
    property="og:description"
    content="Affordable Pune to Kolhapur taxi booking. Choose Sedan & SUV cabs for safe one-way or round-trip travel."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-to-kolhapur-cab" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-to-kolhapur-cab.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Kolhapur Cab | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book Pune to Kolhapur cabs online. One-way & round-trip taxis with professional drivers."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-to-kolhapur-cab.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>


{/*
//by this 9th page
<Helmet>
  <title>Pune to Kolhapur Cab | One Way & Round Trip | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable cab from Pune to Kolhapur with Meghana Cabs. Choose from Sedan, SUV, or AC cars for one-way or round trip travel. Affordable, on-time service with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Kolhapur One Way Taxi, Cab Booking Pune to Kolhapur, Round Trip Cab Pune to Kolhapur, AC Cab from Pune to Kolhapur, Pune to Kolhapur Sedan Taxi, SUV Rental Pune to Kolhapur, Pune to Kolhapur Travel by Car, Outstation Cab Pune to Kolhapur, Pune to Kolhapur Highway Taxi, Budget Cab Pune to Kolhapur, Driver-Included Cabs Pune to Kolhapur, Online Taxi Booking for Kolhapur, Pune to Kolhapur Intercity Cab, Book Hatchback Pune to Kolhapur, Pune to Kolhapur Car Hire Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokolhapurcab;